module.exports = __webpack_public_path__ + "img/imgs.14e4f2a3.png";